export const mediaQuery = {
    mobileMedium: '(min-width: 375px)',
    mobileLarge: '(min-width: 410px)',
    tablet: '(min-width: 768px)',
    laptop: '(min-width: 1024px)',
    laptopLarge: '(min-width: 1440px)',
    monitor: '(min-width: 1500px)',
    monitorLarge: '(min-width: 2000px)'
};

export const PAGE_WIDTH = '1126px';
